import { Deserializer as JSONAPIDeserializer } from 'jsonapi-serializer'

export function deserializeJsonApi(data, keyForAttribute = 'camelCase') {
  const deserializer = new JSONAPIDeserializer({ keyForAttribute })
  return deserializer.deserialize(data)
}
